/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseOfGetRoleTypesResponse } from '../models/ApiResponseOfGetRoleTypesResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RoleTypeService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @deprecated
     * @returns ApiResponseOfGetRoleTypesResponse 
     * @throws ApiError
     */
    public getRoleTypes(): CancelablePromise<ApiResponseOfGetRoleTypesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/role-type/',
        });
    }

}
